module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/rewards/xponential-d1c24129891a34eed8c5fc9bca1284b7.svg";